// ── Notes index ───────────────────────────────────────────────────────────────
//
// Every note, newest first, straight from src/routes.json. There is nothing to
// subscribe to and no email box: the no-gate rule applies to the notes too.

import React from "react";
import { NOTES } from "./routes";
import { NotesShell, formatDate, heading, wrap } from "./notes/chrome";
import type { PageProps } from "./types";

export default function NotesIndex({ brand }: PageProps): React.JSX.Element {
  return (
    <NotesShell brand={brand}>
      <div style={{ ...wrap, maxWidth:760, padding:"44px 24px 64px" }}>
        <div style={{ fontSize:11, color:brand.primary, letterSpacing:"0.2em", fontWeight:700, textTransform:"uppercase", marginBottom:16 }}>Notes</div>
        <h1 style={{ ...heading, fontSize:"clamp(34px, 7vw, 54px)", lineHeight:1.05 }}>The arithmetic nobody does</h1>
        <div style={{ fontSize:16, color:"var(--text-muted)", maxWidth:620, margin:"16px 0 40px", lineHeight:1.7 }}>
          Short, specific notes on vending money — card fees, settlement, commission and margin. Written for the person who
          signs the processor agreement, not for a search engine.
        </div>

        <div style={{ display:"flex", flexDirection:"column", gap:16 }}>
          {NOTES.map((n) => (
            <a key={n.path} href={n.path} style={{ display:"block", background:"var(--surface)", border:"1px solid var(--border-subtle)", borderRadius:10, padding:"22px 22px", textDecoration:"none" }}>
              <div style={{ fontSize:12, color:"var(--text-faint)", marginBottom:8 }}>{formatDate(n.published)}</div>
              <div style={{ ...heading, fontSize:28, lineHeight:1.1, marginBottom:8 }}>{n.ogTitle}</div>
              <div style={{ fontSize:15, color:"var(--text-muted)", lineHeight:1.65 }}>{n.summary}</div>
            </a>
          ))}
        </div>
      </div>
    </NotesShell>
  );
}
